// extracted by mini-css-extract-plugin
module.exports = {"tabBodyItemActive":"tabBodyItemActive-2_zoZQRN","tabBodyItem":"tabBodyItem-1Dq3ReEx"};